import * as React from 'react';

import { useNavigate } from 'js/lib/useRouter';

import { SettingsIcon } from '@coursera/cds-icons';
import type { SectionName } from '@coursera/event-pulse-types';
import { Button as TrackedButton } from '@coursera/event-pulse/react';

import { useEnableAnalyticsSettings } from 'bundles/enterprise-admin-hooks/hooks/useEnableAnalyticsSettings';
import { useEnterpriseAdminTrackingData } from 'bundles/enterprise-admin-hooks/hooks/useEnterpriseAdminTrackingData';
import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';
import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

import _t from 'i18n!nls/enterprise-admin-home';

type Props = {
  sectionName: SectionName;
};

export const CustomizeAnalyticsSettingsButton = (props: Props): React.ReactElement | null => {
  const enableAnalyticsSettings = useEnableAnalyticsSettings();
  const thirdPartyOrganization = useThirdPartyOrganization();
  const enableSeparateReports = EnterpriseExperiments.get('enableSeparateReports').includes(
    thirdPartyOrganization.slug
  );
  const enableBillabeVsNonBillable = EnterpriseExperiments.get('enableBillableVsNonBillableConsistency');

  const navigate = useNavigate();
  const enterpriseAdminTrackingData = useEnterpriseAdminTrackingData();

  return (enableBillabeVsNonBillable || enableSeparateReports) && enableAnalyticsSettings ? (
    <TrackedButton
      icon={<SettingsIcon />}
      iconPosition="before"
      variant="ghost"
      onClick={() => navigate(`/o/${thirdPartyOrganization.slug}/admin/analytics/settings?source=ADMIN_HOME`)}
      trackingData={{
        button: {
          name: 'enterprise_admin_customize',
        },
        pageSection: {
          sectionName: props.sectionName,
        },
        ...enterpriseAdminTrackingData,
      }}
      {...props}
    >
      {_t('Customize')}
    </TrackedButton>
  ) : null;
};

export default CustomizeAnalyticsSettingsButton;
